/**
 * Marker permission IDs assigned by the backend to identify a user's role.
 * Only these 5 IDs are meaningful in the new RBAC system.
 */
export const ROLES = {
  SUPER_ADMIN: 1,
  PERMISSION_V2_CREATOR: 30,
  PERMISSION_V2_ADMIN_VIEW: 31,
  PERMISSION_V2_OPERATOR_MEYREAL: 32,
  PERMISSION_V2_OPERATOR_MEYFI: 33,
}
